const formatUserLocation = user => {
  const { city, regionName, countryName } = user.location;
  return [city, regionName, countryName]
    .filter(item => item != null)
    .slice(0, 2)
    .join(', ');
};

const isAnotherMemberView = (currentUser, dataUser) => currentUser && dataUser?.id !== currentUser?.id;

export { formatUserLocation, isAnotherMemberView };
